import SRD_Form from "components/Form";
import Layout from "components/Layout";
import React from "react";
import ReceiveSettingAddForm from "./components/ReceiveSettingAddForm";

function ReceiveSettingAddPage() {
  return (
    <Layout title="SMS 수신 설정 등록">
      <ReceiveSettingAddForm />
    </Layout>
  );
}

export default ReceiveSettingAddPage;
